import Button from "@qoohoo/common/components/library/Button";

import { dashboardDomain } from "../../constants/domain";
import TranslateAppear from "components/Animation/TranslateAppear";

const creatorOnboardingUrl = `${dashboardDomain}/creator-onboarding`;

export default function GetStarted({theme}) {
  return (
    <section className="w-full px-5 pb-12 pt-16 md:pt-36">
      <div className="w-full flex flex-col items-center relative">
        <TranslateAppear>
          <div className="relative w-fit">
            <h1 className="font-bold text-2xl md:text-5xl">
              Let's get started...
            </h1>
            <img
              src="/assets/images/rocket-black.png"
              alt="rocket"
              className="absolute -top-2 right-4 -translate-y-full translate-x-full w-8 md:w-[4.5rem]"
            />
          </div>
        </TranslateAppear>
        <Button
          className="!h-[2.125rem] md:!h-14 !rounded text-sm md:text-lg text-white mt-6 md:mt-9 w-40 md:w-64"
          onClick={() => {
            window.open(creatorOnboardingUrl, "_blank");
          }}
          style={{ background: theme.accentColor }}
        >
          Become a creator
        </Button>
      </div>
    </section>
  );
}
